'use client';
import React from 'react';
import { useCurrency } from '../context/CurrencyContext'; // <-- FIXED PATH

const Currency = () => {
  const { currencies, selectedCurrency, changeCurrency } = useCurrency();

  if (!selectedCurrency || currencies.length === 0) return null;

  return (
    <select
      value={selectedCurrency.name}
      onChange={(e) => changeCurrency(e.target.value)}
      style={{
                          
                           backgroundColor: "#fff",
                borderColor:"#ccc",
                         
                          padding: "5px 5px",
                       
                          border: "1px solid #ccc",
                          borderRadius: "5px",
                          cursor: "pointer",
                        }}
    >
      {currencies.map(currency => (
        <option key={currency.id} value={currency.name}>
          {currency.name}
        </option>
      ))}
    </select>
  );
};

export default Currency;
